import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer">
      <h3>
        {"@"}
        <br></br>
        <a
          href="https://spire.ee.iisc.ac.in/spire/index.php"
          target="_blank"
          rel="noopener noreferrer"
        >
          SPIRE Lab
        </a>
      </h3>
      <a
        href="https://forms.gle/9XX3jVba7UCtrkWB7"
        target="_blank"
        rel="noopener noreferrer"
      >
        Click here to give us a feedback
      </a>
    </div>
  );
};

export default Footer;
